import { render, staticRenderFns } from "./ModalAddTag.vue?vue&type=template&id=e375e83c&scoped=true&"
import script from "./ModalAddTag.vue?vue&type=script&lang=js&"
export * from "./ModalAddTag.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddTag.vue?vue&type=style&index=0&id=e375e83c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e375e83c",
  null
  
)

export default component.exports